var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg24IcList(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/24_ic_list") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/24_ic_list",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors/Grey",
    transform: "translate(3.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5,6 C0.67,6 0,6.67 0,7.5 C0,8.33 0.67,9 1.5,9 C2.33,9 3,8.33 3,7.5 C3,6.67 2.33,6 1.5,6 Z M1.5,0 C0.67,0 0,0.67 0,1.5 C0,2.33 0.67,3 1.5,3 C2.33,3 3,2.33 3,1.5 C3,0.67 2.33,0 1.5,0 Z M1.5,12.17 C0.76,12.17 0.17,12.77 0.17,13.5 C0.17,14.23 0.77,14.83 1.5,14.83 C2.23,14.83 2.83,14.23 2.83,13.5 C2.83,12.77 2.24,12.17 1.5,12.17 Z M4.5,14.5 L18.5,14.5 L18.5,12.5 L4.5,12.5 L4.5,14.5 Z M4.5,8.5 L18.5,8.5 L18.5,6.5 L4.5,6.5 L4.5,8.5 Z M4.5,0.5 L4.5,2.5 L18.5,2.5 L18.5,0.5 L4.5,0.5 Z",
    id: "Mask"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg24IcList);
export default __webpack_public_path__ + "static/media/24_ic_list.c2b2b245.svg";
export { ForwardRef as ReactComponent };